import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translate, UI_LANGS } from "@/i18n";

const LangContext = createContext(null);
export const useLang = () => useContext(LangContext);

function initialLang() {
  if (typeof window === "undefined") return "en";
  const stored = localStorage.getItem("melletic_lang");
  if (stored && UI_LANGS.some((l) => l.code === stored)) return stored;
  const nav = (navigator.language || "en").slice(0, 2);
  return UI_LANGS.some((l) => l.code === nav) ? nav : "en";
}

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(initialLang);
  const setLang = (code) => setLangState(UI_LANGS.some((l) => l.code === code) ? code : "en");

  useEffect(() => {
    localStorage.setItem("melletic_lang", lang);
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", "ltr");
  }, [lang]);

  const value = useMemo(() => ({
    lang,
    setLang,
    langs: UI_LANGS,
    t: (key, vars) => translate(lang, key, vars),
  }), [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}
